export const isEmpty = (obj: Record<string, unknown>) => {
  return Object.keys(obj).length === 0;
};

export const omitObjectProperty = (obj: Record<any, any>, arr: string[]) =>
  Object.keys(obj)
    .filter((k) => !arr.includes(k))
    .reduce((acc, key) => ((acc[key] = obj[key]), acc), {} as Record<any, any>);
